export default __webpack_public_path__ + "static/media/background.2ee35f3c.jpg";